import "./styles.scss";

import React, { useState } from "react";
import classnames from "classnames";
import queryString from "query-string";
import { navigate } from "gatsby";
import { Field, Form, Formik } from "formik";
import ReactSelect from "../ReactSelect/ReactSelect";

import Input from "components/form/Input";

import { useSearcher } from "context/searcher";

import ArrowIcon from "icons/slider-arrow.svg";
import GridIcon from "icons/grid.svg";
import ListIcon from "icons/search-list.svg";
import CIcon from "icons/condo-pin.svg";

const mainClass = "search-bar";

const search_variant_options = [
  {
    key: "grid",
    icon: <GridIcon />,
    label: "Kafelki",
  },
  {
    key: "list",
    icon: <ListIcon />,
    label: "Lista",
  },
  {
    key: "map",
    icon: <CIcon />,
    label: "Mapa",
  },
];

const SearchBar = ({ variant, pathOnSubmit, view_type, setViewType }) => {
  const {
    state: {
      priceMin,
      priceMax,
      category,
      investment,
      mainTitle,
      surfacemin,
      surfacemax,
      amenities,
      contactLength,
      vacationsDays,
      backPercentage,
    },
    all_investments,
    setPriceMin,
    setPriceMax,
    setCategory,
    setInvestment,
    setMainTitle,
    setSurfacemin,
    setSurfacemax,
    setAmenities,
    setContactLength,
    setVacationsDays,
    setBackPercentage,
    setPage,
  } = useSearcher();

  const [more_options, setMoreOptions] = useState(false);

  const vacation_days = all_investments
    ?.map(({ investments }) => investments?.vacationsDaysCustom)
    .filter(function (value, index, array) {
      return array.indexOf(value) === index;
    })
    .sort();

  const onSubmit = (values) => {
    if (pathOnSubmit) {
      const query = queryString.stringify({
        priceMin: values.priceMin,
        priceMax: values.priceMax,
        category: values.category,
        mainTitle: values.mainTitle,
      });

      return navigate(pathOnSubmit + "?" + query);
    }

    setPriceMin(values.priceMin);
    setPriceMax(values.priceMax);
    setSurfacemin(values.surfacemin);
    setSurfacemax(values.surfacemax);
    setCategory(values.category);
    setInvestment(values.investment);
    setMainTitle(values.mainTitle);
    setAmenities(values.amenities);
    setBackPercentage(values.backPercentage);
    setContactLength(values.contactLength);
    setVacationsDays(values.vacationsDays);
    setPage(undefined);
  };

  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--${variant}`]: !!variant,
      })}
    >
      {variant !== "static" && (
        <h2>
          <strong>Znajdź ofertę</strong> dopasowaną do Twoich wymagań
        </h2>
      )}
      <Formik
        onSubmit={onSubmit}
        enableReinitialize
        initialValues={{
          mainTitle,
          priceMin,
          priceMax,
          category: category || [],
          investment: investment || [],
          vacationsDays: vacationsDays ?? [],
          amenities: amenities ?? [],
          backPercentage: backPercentage ?? [],
          contactLength: contactLength ?? [],
          surfacemin,
          surfacemax,
        }}
      >
        {({
          // values,
          // errors,
          // touched,
          // handleChange,
          // handleBlur,
          handleSubmit,
          // isSubmitting,
        }) => (
          <Form onSubmit={handleSubmit} id="wyszukiwarka-form">
            <div className={`${mainClass}__form`}>
              <div className={`${mainClass}__form__standard-options`}>
                <Field
                  component={Input}
                  placeholder="Cena od"
                  type="text"
                  name="priceMin"
                  sufix="zł"
                  className="test"
                  color="orange"
                />
                <Field
                  component={Input}
                  placeholder="Cena do"
                  type="text"
                  name="priceMax"
                  sufix="zł"
                  color="orange"
                />
                <Field
                  placeholder="Wybierz region"
                  name="category"
                  component={ReactSelect}
                  isMulti
                  options={[
                    { label: "Morze", value: "sea" },
                    { label: "Góry", value: "mountains" },
                    { label: "Mazury", value: "lake" },
                    // { label: "Miasto", value: "city" },
                    { label: "Hiszpania", value: "spain" },
                  ]}
                />
                <Field
                  component={Input}
                  placeholder="Nazwa inwestycji"
                  type="text"
                  name="mainTitle"
                  color="white"
                />
                <button type="submit">Szukaj</button>
              </div>
              {!!more_options && (
                <div className={`${mainClass}__form__more-options`}>
                  <div className={`${mainClass}__form__more-options__row`}>
                    <Field
                      component={Input}
                      placeholder="Metraż od"
                      type="text"
                      name="surfacemin"
                      sufix="m2"
                      className="test"
                      color="white"
                    />
                    <Field
                      component={Input}
                      placeholder="Metraż do"
                      type="text"
                      name="surfacemax"
                      sufix="m2"
                      color="white"
                    />
                    <Field
                      placeholder="Pobyt właścicielski"
                      name="vacationsDays"
                      component={ReactSelect}
                      isMulti
                      options={
                        vacation_days?.map((item) => ({
                          label: item,
                          value: item,
                        }))
                        //   [
                        //   { label: "14 dni", value: "14" },
                        //   { label: "15 dni", value: "15" },
                        //   { label: "21 dni", value: "21" },
                        //   { label: "28 dni", value: "28" },
                        //   { label: "30 dni", value: "30" },
                        //   { label: "365 dni", value: "365" },
                        //   { label: "Brak", value: "none" },
                        //   { label: "Inne", value: "other" },
                        // ]
                      }
                    />
                    <Field
                      placeholder="Udogodnienia"
                      name="amenities"
                      component={ReactSelect}
                      isMulti
                      options={[
                        { label: "Parking", value: "parking" },
                        { label: "SPA", value: "spa" },
                        { label: "Restuaracja", value: "restaurant" },
                        { label: "Narciarnia", value: "skiRoom" },
                        { label: "Recepcja", value: "reception" },
                        { label: "Siłownia", value: "gym" },
                        { label: "Sala konferencja", value: "conferenceRoom" },
                        { label: "Rowerownia", value: "bikeRoom" },
                        { label: "Bar", value: "bar" },
                        { label: "Basen wewnętrzny", value: "poolIn" },
                        { label: "Basen zewnętrzny", value: "poolOut" },
                        { label: "Taras", value: "terrace" },
                        { label: "Aquapark", value: "aquapark" },
                        { label: "Klub nocny", value: "nightclub" },
                        { label: "Sala kominkowa", value: "fireplace" },
                        { label: "Jacuzzi", value: "jacuzi" },
                      ]}
                    />
                  </div>
                  <div className={`${mainClass}__form__more-options__row`}>
                    <Field
                      placeholder="Stopa zwrotu"
                      name="backPercentage"
                      component={ReactSelect}
                      isMulti
                      options={[
                        { label: "7%", value: "7" },
                        { label: "8%", value: "8" },
                        { label: "Inne", value: "inne" },
                      ]}
                    />
                    <Field
                      placeholder="Długość umowy"
                      name="contactLength"
                      component={ReactSelect}
                      isMulti
                      options={[
                        { label: "10 lat", value: "10" },
                        { label: "15 lat", value: "15" },
                        { label: "20 lat", value: "20" },
                        { label: "Inne", value: "inne" },
                      ]}
                    />
                  </div>
                </div>
              )}
              <button type="submit" className="mobile-btn">
                Szukaj
              </button>
            </div>
          </Form>
        )}
      </Formik>
      {variant === "static" && (
        <div className={`${mainClass}__settings`}>
          <button
            onClick={() => setMoreOptions((prev) => !prev)}
            className={classnames(`${mainClass}__settings__show-more`, {
              [`${mainClass}__settings__show-more--active`]: !!more_options,
            })}
          >
            <span>{!!more_options ? "Mniej filtrów" : "Więcej filtrów"}</span>
            <ArrowIcon />
          </button>
          <div className={`${mainClass}__settings__view`}>
            {search_variant_options?.map(({ key, icon, label }, index) => (
              <button
                key={index}
                onClick={() => setViewType(key)}
                className={classnames(`${mainClass}__settings__view__item`, {
                  [`${mainClass}__settings__view__item--active`]:
                    view_type === key,
                })}
              >
                {icon}
                <span>{label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
